export enum PdfEditorType {
  Viewer,
  Editor
}
